import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';
import Value from './common/Value';
import { formatPhone } from '../../utils/utils';

const styles = () => ({
  container: {
    margin: '16px 0px'
  },
  detailsContainer: {
    display: 'flex',
    marginTop: 20,
    flexWrap: 'wrap',
    rowGap: '8px',
    '&:first-of-type': {
      marginTop: 4
    }
  },
  firstChildHazmatMargin: {
    marginTop: 4
  }
});

const HazmatDetails = ({ classes, hazmatInfo, isPickupPro = false }) => {
  return (
    <div className={classes.container}>
      <Label labelText="Hazmat Details" />
      {hazmatInfo.length > 0 ? (
        hazmatInfo.map((hazmat, index) => {
          return (
            <div
              className={`${classes.detailsContainer} ${
                index === 0 ? classes.firstChildHazmatMargin : ''
              }`}
              key={index}>
              <Detail label="UN #" value={hazmat.unNumber} />
              <Detail label="PG #" value={hazmat.pgNumber} />
              <Detail label="Pkg Type" value={hazmat.packageCode} />
              {isPickupPro && (
                <>
                  <Detail label="Emergency#" value={formatPhone(hazmat.emergencyPhone)} />
                  <Detail label="Bulk" value={hazmat.bulk ? 'Yes' : 'NA'} />
                </>
              )}
            </div>
          );
        })
      ) : (
        <Value value="NA" customClasses={classes.firstChildHazmatMargin} />
      )}
    </div>
  );
};

export default withStyles(styles)(HazmatDetails);
